<div *ngIf="(assignmentDetailsStateService.assignmentDetails | async)" class="date-table">
  
    <!-- Header Row -->
    <div class="date-item">
        <!-- Date column with fixed width -->
        <div class="date-item-date gap-3">
            <label>{{ 'assignments.courseDates.date' | transloco }}</label>
        </div>
        <div class="location-header">
            <label>{{ 'assignments.courseDates.location' | transloco }}</label>
        </div>
    </div>

    <!-- Divider between title and list -->
    <hr class="light-divider p-0 m-0">

    <!-- Data Rows -->
    <ng-container *ngFor="let assignmentDate of assignmentDates; let i = index">        
        <hr class="light-divider p-0 m-0" *ngIf="i != 0">     
        <div class="date-item gap-3 align-items-center">
            <!-- Date Column -->
            <div class="date-item-date">
                <!-- Different Start and End Dates -->
                <ng-container *ngIf="!IsOnSameDay(assignmentDate)">
                    <div class="d-flex flex-column">
                        <!-- Start Date and Time -->
                        <div>
                            {{ assignmentDate.from | date: "dd.MM.YY | HH.mm" }}
                        </div>

                        <!-- End Date and Time -->
                        <div>
                            {{ assignmentDate.to | date: "dd.MM.YY | HH.mm" }}
                        </div>
                    </div>
                </ng-container>

                <!-- Single Date and Time -->
                <ng-container *ngIf="IsOnSameDay(assignmentDate)">
                    <div class="d-flex flex-column">
                        <!-- Date Section -->
                        <div>
                            {{ assignmentDate.from | date: 'dd.MM.YY' }}
                        </div>
                        <div>
                            {{ assignmentDate.from | date: 'HH.mm' }} - {{ assignmentDate.to | date: 'HH.mm' }}
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- Location Column -->
            <div class="px-1">
              <ng-container *ngIf="assignmentDate.location != null">
                <span class="d-inline">{{ assignmentDate.location }}</span>
              </ng-container>
              <ng-container *ngIf="assignmentDate.location == null">
                <span *ngIf="!assignmentDate?.locations?.length">-</span>
                <span *ngFor="let location of assignmentDate?.locations" class="d-inline">
                  {{ location.facility }} | {{ location.room }}
                </span>
              </ng-container>

              <!-- Sub Event Title Column -->
              <ng-container *ngIf="assignmentDate.subEventTitle != null">
                <span class="fw-bold d-block d-sm-inline">
                  <span class="d-none d-sm-inline"> | </span>
                  {{ assignmentDate.subEventTitle }}
                </span>
              </ng-container>
            </div>
        </div>
    </ng-container>
</div>
